import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d21fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = {
  ref: "textDiv",
  class: "textDiv"
}
const _hoisted_3 = {
  ref: "mypageNameHeader",
  class: "name-label"
}
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = { class: "bold" }
const _hoisted_6 = {
  src: "/assets/icon/angel.png",
  srcset: "/assets/icon/angel@2x.png 2x,/assets/icon/angel@3x.png 3x"
}
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = {
  src: "/assets/icon/angel.png",
  srcset: "/assets/icon/angel@2x.png 2x,/assets/icon/angel@3x.png 3x"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, " >", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/settings.png",
    srcset: "/assets/icon/settings@2x.png 2x,/assets/icon/settings@3x.png 3x"
  })
], -1))
const _hoisted_11 = { class: "user_wrap" }
const _hoisted_12 = {
  id: "userInfo",
  ref: "walletBox",
  class: "user-info"
}
const _hoisted_13 = { class: "invest-info" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-money" }, null, -1))
const _hoisted_15 = { class: "invest-box" }
const _hoisted_16 = {
  ref: "pointBox",
  class: "point-box"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 포인트 ", -1))
const _hoisted_18 = { class: "charge-money" }
const _hoisted_19 = { class: "bold" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn_w",
  src: "/assets/icon/btn_right_w.png",
  srcset: "/assets/icon/btn_right_w@2x.png 2x,/assets/icon/btn_right_w@3x.png 3x"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 초대 · 할인코드 입력 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 나의 초대링크 공유 ", -1))
const _hoisted_23 = { class: "container_wrap" }
const _hoisted_24 = { class: "main-container" }
const _hoisted_25 = { class: "main_padding" }
const _hoisted_26 = {
  key: 0,
  class: "graybox_wrap"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 입금 정보 ")
], -1))
const _hoisted_28 = { class: "graybox-radius" }
const _hoisted_29 = { class: "partnership_name" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue text" }, " (입금 완료) ", -1))
const _hoisted_31 = { class: "graybox-radius" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 참여 취소 > ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 입금계좌 복사 > ")
const _hoisted_37 = { class: "graybox-radius" }
const _hoisted_38 = { class: "partnership_name" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red text" }, " (조기마감) ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 입금 내역이 있는 경우, 입력하신 본인명의 환불계좌로 1영업일 내에 환불됩니다. ", -1))
const _hoisted_41 = { style: {"margin-top":"12px"} }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('환불계좌 입력 >'))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 거래 현황 ")
], -1))
const _hoisted_44 = { class: "nbox-radius" }
const _hoisted_45 = { class: "ion-activatable ripple-parent circle" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 협의중 ", -1))
const _hoisted_47 = { class: "ion-activatable ripple-parent circle" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 조합설립중 ", -1))
const _hoisted_51 = { class: "ion-activatable ripple-parent circle" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text" }, " 서명중 ", -1))
const _hoisted_53 = { class: "main-title" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 지분 거래 내역 ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "상세보기"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "right_btn",
    src: "/assets/icon/btn_right.png",
    srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
  })
], -1))
const _hoisted_56 = { class: "wbox-radius" }
const _hoisted_57 = { class: "wbox-content" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, " 최근 거래 ", -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "deal-name" }
const _hoisted_61 = { class: "deal-right" }
const _hoisted_62 = { class: "deal-price" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 아직 조합원 자격 거래하신 내역이 없습니다. ")
const _hoisted_64 = { class: "main-title" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 투자 자산 현황 ", -1))
const _hoisted_66 = { class: "ion-activatable ripple-parent right" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "상세보기", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_69 = { class: "wbox-radius" }
const _hoisted_70 = { class: "comb-title" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "조합원 자격 보유", -1))
const _hoisted_72 = { class: "comb-money" }
const _hoisted_73 = { class: "strong" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_75 = { class: "deal-info" }
const _hoisted_76 = { class: "c_logo" }
const _hoisted_77 = ["src"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_79 = { class: "overflow" }
const _hoisted_80 = { class: "deal-price" }
const _hoisted_81 = { class: "comb-title" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "조합 설립중", -1))
const _hoisted_83 = { class: "comb-money" }
const _hoisted_84 = { class: "strong" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_86 = { class: "deal-info" }
const _hoisted_87 = { class: "c_logo" }
const _hoisted_88 = ["src"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_90 = { class: "overflow" }
const _hoisted_91 = { class: "deal-price" }
const _hoisted_92 = { class: "comb-title" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "EXIT", -1))
const _hoisted_94 = { class: "comb-money" }
const _hoisted_95 = { class: "strong" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_97 = { class: "deal-info" }
const _hoisted_98 = { class: "c_logo" }
const _hoisted_99 = ["src"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_101 = { class: "overflow" }
const _hoisted_102 = { class: "deal-price" }
const _hoisted_103 = { class: "main-title" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " 스톡옵션 ", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "상세보기", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_107 = { class: "wbox-radius" }
const _hoisted_108 = { class: "wbox-content" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comb-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "comb-status" }, "보유현황")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션 세금계산기 > ", -1))
const _hoisted_111 = { class: "deal-info" }
const _hoisted_112 = { class: "c_logo" }
const _hoisted_113 = ["src"]
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_115 = { class: "overflow" }
const _hoisted_116 = { class: "deal-price" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" 1:1 문의 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_nft_mint_banner = _resolveComponent("nft-mint-banner")!
  const _component_notification = _resolveComponent("notification")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_wallet_request_modal = _resolveComponent("wallet-request-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        fullscreen: true,
        "scroll-events": true,
        onIonScroll: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleScroll($event.target)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, null, 512),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.isCreator)
                  ? (_openBlock(), _createBlock(_component_ag_box_s, {
                      key: 0,
                      css: {}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name) + " 님", 1),
                        _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                          [_vShow, _ctx.isLead]
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_nft_mint_banner, {
                      key: 1,
                      "link-url": "/pages/nft/my-page"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.name) + " 님 ", 1),
                        _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                          [_vShow, _ctx.isLead]
                        ]),
                        _hoisted_9
                      ]),
                      _: 1
                    }))
              ]),
              (_ctx.showNotificationButton)
                ? (_openBlock(), _createBlock(_component_ag_box_s, {
                    key: 0,
                    css: {mr: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_notification)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                class: "ion-activatable ripple-parent",
                to: "/settings",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'설정버튼영역', 'clickContent':'설정버튼클릭'});})
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _: 1
              })
            ], 512),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_router_link, { to: {name:'MyPoint'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, {
                            class: "ion-activatable ripple-parent point-box-item",
                            css: {p: 16, color: 'white'},
                            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'포인트클릭'});})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17,
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$filters.currency(_ctx.point)) + " P", 1),
                                _hoisted_20
                              ]),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_box_s, { css: {height: 1, width: '100%', bg: 'white', opacity: 0.2} }, null, 8, ["css"]),
                      _createVNode(_component_ag_box_s, { css: {dp: 'flex', direction: 'row', p: 16} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, {
                            css: {typography: 'tit14b', grow: 1, textAlign: 'center'},
                            class: "ion-activatable ripple-parent",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'초대할인코드입력'});_ctx.createModal()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21,
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ag_box_s, { css: {width: 1, height: 12, bg: 'white', opacity: 0.2, margin: 'auto'} }, null, 8, ["css"]),
                          _createVNode(_component_ag_box_s, {
                            "container-as": "button",
                            disabled: !_ctx.link,
                            css: {typography: 'tit14b', grow: 1, textAlign: 'center', bg: 'transparent', color: 'white'},
                            class: "ion-activatable ripple-parent",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단 투자금액&포인트영역', 'clickContent':'나의초대링크공유'});_ctx.onShare()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22,
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ], 512)
                  ])
                ])
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (
                _ctx.depositInfo.paid && _ctx.depositInfo.paid.length ||
                  _ctx.depositInfo.notYet && _ctx.depositInfo.notYet.length ||
                  _ctx.depositInfo.earlyClose && _ctx.depositInfo.earlyClose.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depositInfo.paid, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: v.partnershipRequestId,
                            class: "deposit_info"
                          }, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(v.partnershipName), 1),
                            _hoisted_30
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.depositInfo.paid && _ctx.depositInfo.paid.length]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depositInfo.notYet, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: v.partnershipRequestId,
                            class: "deposit_info"
                          }, [
                            _createVNode(_component_ag_text_s, { css: {typography: 'text16m', mb: '4px'} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(v.partnershipName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_32,
                            _createVNode(_component_ag_text_s, { css: {color: 'red2', typography: 'main14r', mb: '4px'} }, {
                              default: _withCtx(() => [
                                _createTextVNode(" (입금 가능 기한 " + _toDisplayString(v.timeDiff) + "시간 전) ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_33,
                            _createVNode(_component_ag_text_s, { css: {typography: 'main14r', mb: '4px'} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(v.bank) + " " + _toDisplayString(v.bankno) + " " + _toDisplayString(v.bankholder), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_34,
                            (v.asset)
                              ? (_openBlock(), _createBlock(_component_ag_text_s, {
                                  key: 0,
                                  css: {typography: 'main14r', mb: '4px'}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 금액 " + _toDisplayString(_ctx.$filters.currency(v.asset)) + " 원 ", 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ag_box_s, { css: {mt: '12px'} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_text_s, {
                                  css: {color: 'gray2', typography: 'main14r', mr: '16px'},
                                  onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'입금정보안내', 'clickContent':'클럽딜참여취소'}); _ctx.openAlert('clubdeal', 'cancel', v)}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_35
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_ag_text_s, {
                                  css: {typography: 'main14r', color: 'gray2'},
                                  onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'입금정보안내', 'clickContent':'클럽딜입금계좌복사'}); _ctx.copyText(`${v.bank} ${v.bankno} ${v.bankholder}`)}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_36
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.depositInfo.notYet && _ctx.depositInfo.notYet.length]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.depositInfo.earlyClose, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: v.partnershipRequestId,
                            class: "deposit_info"
                          }, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(v.partnershipName), 1),
                            _hoisted_39,
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_ag_text_s, {
                                css: {typography: 'main14r', color: 'gray2', marginRight: '16px',},
                                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'입금정보안내', 'clickContent':'환불계좌 입력'}); _ctx.router.push('/settings')})
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_42
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.depositInfo.earlyClose && _ctx.depositInfo.earlyClose.length]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent inline-content",
                    onClick: _cache[6] || (_cache[6] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'거래현황', 'clickContent':'협의중'})
                  _ctx.router.push('/tabs/channel-list')
                })
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.groupChannels), 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    _hoisted_46
                  ]),
                  _createElementVNode("div", {
                    class: "inline-content",
                    onClick: _cache[7] || (_cache[7] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'거래현황', 'clickContent':'조합설립중'})
                  _ctx.router.push({ name : 'MyAsset', params : { scroll : 'ing'}})
                })
                  }, [
                    _createElementVNode("div", _hoisted_47, [
                      (_ctx.partnershipCollecting.list && _ctx.partnershipCollecting.list.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.partnershipCollecting.list.length), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_49, "0")),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    _hoisted_50
                  ]),
                  _createElementVNode("div", {
                    class: "inline-content",
                    onClick: _cache[8] || (_cache[8] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'거래현황', 'clickContent':'서명중'})
                  _ctx.router.push({ name : 'ContractStatus'})
                })
                  }, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.docusign.length), 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    _hoisted_52
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_ag_box_s, {
                    css: {
                },
                    onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분거래내역', 'clickContent':'상세보기'});
                        _ctx.router.push({name : 'DealHistory', params: {scroll : 'own'}})})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_router_link, {
                  to: {name:'DealHistory'},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분거래내역', 'clickContent':'목록'});})
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        (_ctx.shareTransactions && _ctx.shareTransactions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shareTransactions, (stake, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: "deal-history"
                                }, [
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(stake.partnershipName), 1),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$filters.currency(_ctx.transactionPrice(stake))) + " 원 ", 1),
                                    _createVNode(_component_ag_text_s, {
                                      css: {typography: 'main14r', color: stake.type === '구매' ? '#4360EC' : '#00B7B9', lineHeight:'21px'}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(stake.type), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["css"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_ag_text_s, {
                              key: 1,
                              css: {color: 'gray3', typography: 'list15r'}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_63
                              ]),
                              _: 1
                            }))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_router_link, {
                    to: {name:'MyAsset', query: {from: '/tabs/mypage/'}},
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'투자자산현황', 'clickContent':'상세보기'});})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _hoisted_68,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent wbox-content divide-margin",
                    onClick: _cache[12] || (_cache[12] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'투자자산현황', 'clickContent':'지분 보유 목록'});
                  _ctx.router.push({name : 'MyAsset', params: {scroll : 'own'}})
                })
                  }, [
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("span", _hoisted_72, [
                        _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipComplete.totalAsset)), 1),
                        _hoisted_74
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipComplete.list, (deal) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "comb-content"
                      }, [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("img", {
                              src: deal.companyLogo ? deal.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-circle img-responsive"
                            }, null, 8, _hoisted_77),
                            _hoisted_78
                          ]),
                          _createElementVNode("span", _hoisted_79, _toDisplayString(deal.partnershipName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$filters.currency(Math.floor(deal.asset))) + " 원 ", 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent wbox-content divide-margin",
                    onClick: _cache[13] || (_cache[13] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'투자자산현황', 'clickContent':'조합 설립중 목록'});
                  _ctx.router.push({name : 'MyAsset', params: {scroll : 'ing'}})
                })
                  }, [
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("span", _hoisted_83, [
                        _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipCollecting.totalAsset)), 1),
                        _hoisted_85
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipCollecting.list, (deal) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "comb-content"
                      }, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("img", {
                              src: deal.companyLogo ? deal.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-circle img-responsive"
                            }, null, 8, _hoisted_88),
                            _hoisted_89
                          ]),
                          _createElementVNode("span", _hoisted_90, _toDisplayString(deal.partnershipName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$filters.currency(deal.asset)) + " 원 ", 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent wbox-content divide-margin",
                    onClick: _cache[14] || (_cache[14] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'투자자산현황', 'clickContent':'EXIT 목록'});
                  _ctx.router.push({name : 'MyAsset', params: {scroll : 'exit'}})
                })
                  }, [
                    _createElementVNode("div", _hoisted_92, [
                      _hoisted_93,
                      _createElementVNode("span", _hoisted_94, [
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$filters.currency(_ctx.exit.totalAsset)), 1),
                        _hoisted_96
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exit.list, (deal) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: deal.partnershipId,
                        class: "comb-content"
                      }, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("img", {
                              src: deal.companyLogo ? deal.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-circle img-responsive"
                            }, null, 8, _hoisted_99),
                            _hoisted_100
                          ]),
                          _createElementVNode("span", _hoisted_101, _toDisplayString(deal.partnershipName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$filters.currency(parseInt(deal.asset))) + " 원 ", 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  _createVNode(_component_router_link, { to: {name:'StockOption'} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent right",
                        onClick: _cache[15] || (_cache[15] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'상세보기'})
                    _ctx.router.push({name:'StockOption'})
                  })
                      }, [
                        _hoisted_105,
                        _hoisted_106,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent stock-info",
                      onClick: _cache[16] || (_cache[16] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'스톡옵션세금계산기'})
                    _ctx.router.push({name:'StockOption', params : {scroll: 'calc'}})
                  })
                    }, [
                      _hoisted_110,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockOption, (stock) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: stock.stockOptionId,
                        class: "comb-content",
                        onClick: _cache[17] || (_cache[17] = () => {
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'스톡옵션', 'clickContent':'목록'})
                    _ctx.router.push({name:'StockOption'})
                  })
                      }, [
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("img", {
                              src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                              onerror: "this.src='/assets/icon/company_default_img.png'",
                              class: "img-circle img-responsive"
                            }, null, 8, _hoisted_113),
                            _hoisted_114
                          ]),
                          _createElementVNode("span", _hoisted_115, _toDisplayString(stock.companyName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$filters.currency(stock.asset)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', gap: 'sp4', px: '20px', pt: '24px'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_button, {
                    css: {typography: 'tit14b', width: '100%', fill: 'indigo1'},
                    onClickCapture: _cache[18] || (_cache[18] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단설명영역', 'clickContent':'1:1문의'}); _ctx.openChannelTalk()})
                  }, {
                    default: _withCtx(() => [
                      _hoisted_117
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_wallet_request_modal, {
            "open-type": _ctx.openType,
            "is-open": _ctx.depositRequestOpen,
            onCloseWithResult: _ctx.branchResult,
            onClose: _cache[19] || (_cache[19] = () => _ctx.depositRequestOpen = false)
          }, null, 8, ["open-type", "is-open", "onCloseWithResult"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}